import type { Seal_Motor_Oil, Seals } from "gql/api";
import type { Maybe } from "graphql/jsutils/Maybe";
import type { SealsExpansionData } from "./types";
import {
  getLowerTandemSealData,
  getUpperTandemSealData
} from "./tandemExpansion";

// Calcs can be found in static/Seal Calc Rework 10.xlsx
export function getSealExpansionInformation(
  primarySeal: Maybe<Partial<Seals>>,
  bottomSeal: Maybe<Partial<Seals>>,
  bottomholeTempF: number,
  surfaceTempF: number,
  motorOilVolumeGal: number,
  baseWindingOperatingTempF: number,
  motorSkinTemperatureF: number,
  datumDepthFt: number,
  sealMotorOil: Seal_Motor_Oil | null | undefined,
  motorDepthFt: number,
  lowerSealDepthFt: number,
  topSealDepthFt: number
): SealsExpansionData {
  const motorOilCoeff = sealMotorOil?.thermal_expansion_factor || 0;
  const gradientFPerFt = (bottomholeTempF - surfaceTempF) / datumDepthFt;

  const lowerTandemData = getLowerTandemSealData(
    primarySeal,
    bottomSeal,
    motorOilCoeff,
    gradientFPerFt,
    motorDepthFt,
    lowerSealDepthFt,
    topSealDepthFt,
    motorOilVolumeGal,
    surfaceTempF,
    motorSkinTemperatureF,
    baseWindingOperatingTempF
  );
  // Seal will be null if there's only one seal
  const upperTandemData = getUpperTandemSealData(
    bottomSeal ? primarySeal : null,
    motorOilCoeff,
    gradientFPerFt,
    topSealDepthFt,
    motorSkinTemperatureF,
    surfaceTempF,
    lowerTandemData.install.totalExpansionGal || 0,
    lowerTandemData.operation.totalExpansionGal || 0,
    lowerTandemData.pull.totalExpansionGal || 0,
    lowerTandemData.totalContractionVolumeGal
  );

  return {
    lowerTandem: lowerTandemData,
    upperTandem: upperTandemData
  };
}
